import { createAsyncThunk } from '@reduxjs/toolkit';

import scribeDocumentService from '../../services/scribeDocumentService';

export const exportScribeDocument = createAsyncThunk('scribeDocuments/export', async (args = { id: null, format: null }) => {
  const { id, format } = args;
  const response = await scribeDocumentService.exportScribeDocument(id, format);

  return {
    id,
    thumbnailUnpackStatus: response.thumbnail_unpack_status,
    exportedData: response.exported_data
  };
});
